import { render, staticRenderFns } from "./SuspensionNotActionable.vue?vue&type=template&id=72ca68b4&"
import script from "./SuspensionNotActionable.vue?vue&type=script&lang=js&"
export * from "./SuspensionNotActionable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports